/**
 * /admin/branding/custom-domain — Custom domain wizard (route shell).
 * Screen impl in `./branding.custom-domain-screen.tsx`, lazy-loaded.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/branding/custom-domain')({
  component: lazyRouteComponent(
    () => import('./branding.custom-domain-screen'),
    'CustomDomainPage',
  ),
});
